<template>
    <div class="menu" v-if="!isMobile || showMenu">
        <div v-for="(item, index) in menuList" class="menu-item" :class="language == 'en' ? 'menu-item-en' : ''" @mouseenter="handleMouseEnter(index)" @mouseleave="handleMouseLeave(index)">
            <div class="item" :class="{'menu-active': isActive(item) }">
                <div @click="handleClick(item)">{{ item.title }}</div>
                <img src="@assets/media/icon_select.png" 
                     srcset="@assets/media/icon_select@2x.png 2x"
                     :class="mouseIndex === index ? 'show-type' : ''" 
                     v-if="isMobile && item.children"
                     @click="mobileShowSubMenu(index)" />
            </div>
            <div v-if="item.children && mouseIndex === index" class="menu-sub">
                 <div v-for="(subItem, subIndex) in item.children"
                     :key="subIndex"
                     :class="{'menu-sub-active': activeSub === subItem.route_path }" 
                      class="menu-sub-children"
                      @click="handleSubClick(subItem, item)">{{ subItem.title }}</div>
            </div>
        </div>
    </div>
</template>
<script setup>
    import { onMounted, ref, watch, defineEmits, defineProps } from 'vue';
    import { MenuListAPI } from '@/api/common';
    import { useRouter, useRoute } from 'vue-router'
    const router = useRouter()
    const route = useRoute();
    const emit = defineEmits(['close'])

    // 语言包
    const language = localStorage.getItem("language") || "zh"

    // showMenu 移动端是否显示菜单
    defineProps({
        showMenu: { type: Boolean, default: false }
    })
    // 菜单列表
    const menuList = ref([]);
    // 主菜单选中
    const active = ref(1)
    // 子菜单选中
    const activeSub = ref('')
    // 鼠标移入的菜单索引
    const mouseIndex = ref('')
    // 鼠标移出延时定时器
    const timer = ref(null)

    // 点击一级菜单事件
    const handleClick = (item) => {
        if(!item.route_path) return 
        active.value = item.route_path;
        activeSub.value = '';
        let [path, hash] = item.route_path.split('#')
        router.push({ path, hash: hash ? `#${hash}` : '' })
        if(isMobile.value) emit('close')
    }

    // 点击二级菜单事件
    const handleSubClick = (item, parentItem) => {
        if(!item.route_path) return 
        activeSub.value = item.route_path;
        active.value = parentItem.route_path;
        let [path, hash] = item.route_path.split('#')
        router.push({ path, hash: hash ? `#${hash}` : '' })
        if(isMobile.value) emit('close')
    }

    // 鼠标移入事件
    const handleMouseEnter = (index) => {
        if(isMobile.value) return 
        mouseIndex.value = index
        clearTimeout(timer.value)
    }

    // 鼠标移出事件
    const handleMouseLeave = (index) => {
        if(isMobile.value) return 
        timer.value = setTimeout(() => {
            mouseIndex.value = ''
        }, 500)
    }

    // 移动端显示二级菜单
    const mobileShowSubMenu = (index) => {
        mouseIndex.value = mouseIndex.value === index ? '' : index
    }

    // 获取菜单列表
    async function getMenuList() {
        const res = await MenuListAPI();
        menuList.value = res;
        setActitve()
    }

    // 设置主菜单和子菜单选中
    const setActitve = () => {
        menuList.value.find(item => {
            let [path] = item.route_path?.split('#')
            if(path === route.path) {
                active.value = item.route_path;
                activeSub.value = '';
            } else if(item.children?.length) {
                item.children.find(subItem => {
                    let subPath = subItem.route_path?.split('#')
                    if(subPath?.[0] === route.path) {
                        activeSub.value = subItem.route_path;
                        active.value = item.route_path;
                    }
                })
            }       
        })
    }

    function isActive(item) {
        if (item.route_path && item.route_path === active.value) return true
        if (item.children?.length) {
            return item.children.some(i => i.route_path && (i.route_path === activeSub.value))
        }
        return false
    }
    
    // 设备类型: 是否移动端
    const isMobile = ref(false);

    // 判断设备类型
    function detectDeviceType() {
        const userAgent = navigator.userAgent;
        isMobile.value = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    }

    onMounted(() => {
        getMenuList()
        detectDeviceType()
    });

    watch(
        () => route.path,
        () => {   
            console.log('当前路由', route.path)
            setActitve()
        }
    )

</script>

<style lang="scss" scoped>
    .menu {
        display: flex;
        color: #333333;
        font-weight: 400;
        font-size: 20px;
        margin-left: 30px;
        height: 32px;
        width: 1010px;

        .logo{
            margin-right: 30px;
        }
        
        &-item {
            margin: 0 20px;
            cursor: pointer;
            position: relative;
            line-height: 28px;
            padding-bottom: 4px;
            transition: all 0.3s ease;
        }

        &-active {
            font-family: PingFangSC-medium;
            color: #181E5F;
            font-weight: 500;
            font-size: 20px;
            border-bottom: 3px solid #181E5F;
        }

        &-item-en {
            font-size: 18px !important;
            margin: 0 15px !important;

            .menu-active {
                font-size: 18px !important;
            }
        }

        .item:hover {
            color: #181E5F;
            font-weight: 500;
        }

        &-sub{
            position: absolute;
            text-align: center;
            top: 35px;
            min-width: 148px;
            color: #333333;
            font-weight: 400;
            font-size: 18px;
            margin-left: -74px;
            left: 50%;
            z-index: 99;
            
            &-children {
                margin: 8px auto;
                border-radius: 22px;
                min-width: 148px;
                line-height: 25px;
                padding: 9px;
                background-color: #F0F7FF;
                box-sizing: border-box;
            }

            &-children:hover {
                background: linear-gradient(90deg, rgba(19, 94, 205, 1) 0%, rgba(12, 72, 161, 1) 100%);
                color: #fff;
            }

            &-active {
                background: linear-gradient(90deg, rgba(19, 94, 205, 1) 0%, rgba(12, 72, 161, 1) 100%);
                color: #fff;
            }
        }
        
    }
    /* 响应式设计 */
@media (max-width: 768px) {
    .menu {
        width: 100%;
        height: 200vh;
        position: absolute;
        top: 56px;
        left: 0px;
        border-top: 1px solid #EBEBEB;
        background-color: #fff;
        display: block;
        z-index: 99;
        padding-top: 24px;

        &-item {
            margin: 30px 30px 30px 109px;
            position: relative;
            padding-bottom: 0px;
            transition: all 0.3s ease;
            margin-top: 0px;
            font-family: PingFangSC-medium;
            color: #333333;
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            letter-spacing: 1px;

            .item {
                display: flex;
                align-items: center;
                justify-content: space-between;

                img {
                    transition: transform 0.25s ease;
                }

                .show-type {
                    transform: rotate(-180deg);
                }
            }
        }

        &-active {
            font-size: 14px;
            border-bottom: 0px solid #181E5F;
        }

        &-item-en {
            font-size: 14px !important;
            margin: 30px 30px 30px 109px;
            
            .menu-active {
                font-size: 14px;
            }
        }

        &-sub{
            position: static;
            text-align: left;
            top: 30px;
            min-width: 148px;
            font-weight: 400;
            font-size: 14px;
            margin-left: 5px;
           
            
            &-children {
                margin: 30px 0;
                border-radius: 22px;
                line-height: 16px;
                background-color: #FFFFFF;
                font-weight: 400 !important;
            }

            &-children:hover {
                background: #FFFFFF;
                color: #181E5F;
            }

            &-active {
                background: #FFFFFF;
                color: #181E5F;
            }
        }
        
    }
}
</style>